/** Rubric v2.0 — one contract shared by the API, workbench and exports. */
export const RUBRIC_VERSION = "2.0" as const;

export const SCORE_ANCHORS = [
  { value: 0, label: "不可用", detail: "完全错误、无法辨识或完全听不懂" },
  { value: 0.25, label: "较差", detail: "明显问题，需要反复确认" },
  { value: 0.5, label: "一般", detail: "基本可判断，但有明显瑕疵" },
  { value: 0.75, label: "良好", detail: "有小问题，不影响整体理解" },
  { value: 1, label: "清晰", detail: "准确、稳定，无需猜测" },
] as const;

export const RUBRIC_WEIGHTS = {
  readingChar: { initial: 0.4, final: 0.4, tone: 0.2 },
  singingChar: { onset: 0.3, nucleus: 0.4, coda: 0.3 },
  readingUtterance: { accuracy: 0.35, completeness: 0.15, fluency: 0.2, prosodic: 0.15 },
  singingUtterance: { intelligibility: 0.55, rhythm: 0.45 },
} as const;

export const RUBRIC_DIMENSIONS = {
  reading: [
    ["initial", "声母", "发音部位与送气/不送气准确"],
    ["final", "韵母", "韵头、韵腹、韵尾完整"],
    ["tone", "声调", "调类与曲线方向正确"],
    ["accuracy", "准确度", "字音与目标读法一致"],
    ["completeness", "完整度", "没有漏字、吞字、加字"],
    ["fluency", "流畅度", "停连自然、无明显卡顿"],
    ["prosodic", "表达", "重音、语气和节奏合适"],
  ],
  singing: [
    ["onset", "字头", "起音及时，辅音清楚"],
    ["nucleus", "字腹", "元音稳定，音色与音高集中"],
    ["coda", "字尾", "收音完整，不拖不丢"],
    ["intelligibility", "可懂度", "歌词无需猜测即可听懂"],
    ["rhythm", "节奏", "字音落点与节拍一致"],
  ],
} as const;

export const MERGE_RULES = {
  agreeMaxDelta: 0.1,
  discussMaxDelta: 0.25,
  note: "离散字段冲突直接仲裁；空白不当作 0。",
} as const;
